import { createSlice } from "@reduxjs/toolkit";

const weekStartBySummaryReportId = {
  "summary-report-2026-w33": 1786291200,
  "summary-report-2026-w32": 1785686400,
  "summary-report-2026-w31": 1785081600,
};

const getWeekStartSecs = (summaryReportId) => {
  return weekStartBySummaryReportId[summaryReportId] ?? 1786291200;
};

export const getSummaryReportDevicesMock = ({ summaryReportId }) => {
  const T = getWeekStartSecs(summaryReportId);
  const Hour = 3600;

  return {
    data: {
      items: [
      {
        deviceType: "Switch",
        deviceName: "Core-Switch-01",
        ipAddress: "192.168.160.10",
        macAddress: "28:3B:62:24:24:24",
        segments: [
          {
            status: "online",
            startedAt: T,
            endedAt: T + 7 * 24 * Hour,
          },
        ],
      },
      {
        deviceType: "Access Point",
        deviceName: "AP-Lobby-01",
        ipAddress: "192.168.160.11",
        macAddress: "28:3B:62:24:24:25",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      {
        deviceType: "Access Point",
        deviceName: "AP-Meeting-02",
        ipAddress: "192.168.160.12",
        macAddress: "28:3B:62:24:24:26",
        segments: [
          { status: "online", startedAt: T, endedAt: T + 25 * Hour },
          { status: "offline", startedAt: T + 25 * Hour, endedAt: T + 27 * Hour },
          { status: "online", startedAt: T + 27 * Hour, endedAt: T + 7 * 24 * Hour },
        ],
      },
      {
        deviceType: "Switch",
        deviceName: "Floor-2-Switch-01",
        ipAddress: "192.168.160.13",
        macAddress: "28:3B:62:24:24:27",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      {
        deviceType: "Gateway",
        deviceName: "Gateway-01",
        ipAddress: "192.168.160.1",
        macAddress: "28:3B:62:24:24:28",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      {
        deviceType: "Access Point",
        deviceName: "AP-Cafeteria-01",
        ipAddress: "192.168.160.14",
        macAddress: "28:3B:62:24:24:29",
        segments: [
          { status: "online", startedAt: T, endedAt: T + 42 * Hour + 20 * 60 },
          { status: "offline", startedAt: T + 42 * Hour + 20 * 60, endedAt: T + 44 * Hour + 20 * 60 },
          { status: "online", startedAt: T + 44 * Hour + 20 * 60, endedAt: T + 7 * 24 * Hour },
        ],
      },
      {
        deviceType: "Switch",
        deviceName: "Floor-3-Switch-01",
        ipAddress: "192.168.160.15",
        macAddress: "28:3B:62:24:24:2A",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      {
        deviceType: "Access Point",
        deviceName: "AP-Office-East-01",
        ipAddress: "192.168.160.16",
        macAddress: "28:3B:62:24:24:2B",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      {
        deviceType: "Access Point",
        deviceName: "AP-Office-West-01",
        ipAddress: "192.168.160.17",
        macAddress: "28:3B:62:24:24:2C",
        segments: [
          { status: "online", startedAt: T, endedAt: T + 16 * Hour },
          { status: "offline", startedAt: T + 16 * Hour, endedAt: T + 18 * Hour },
          { status: "online", startedAt: T + 18 * Hour, endedAt: T + 7 * 24 * Hour },
        ],
      },
      {
        deviceType: "Camera",
        deviceName: "Camera-Entrance-01",
        ipAddress: "192.168.160.18",
        macAddress: "28:3B:62:24:24:2D",
        segments: [{ status: "online", startedAt: T, endedAt: T + 7 * 24 * Hour }],
      },
      ],
    },
  };
};

const initialState = {
  data: {
    items: [],
  },
};

export const summaryReportDevicesSlice = createSlice({
  name: "summaryReportDevices",
  initialState,
});

export default summaryReportDevicesSlice.reducer;
